import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';

const state = {
  numOptions: [
    { value: 10, text: '10개' },
    { value: 30, text: '30개' },
    { value: 50, text: '50개' }
  ]
};

class Pagerow extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.handleChange(null, { value: 10 });
  }

  handleChange = async (e, data) => {
    const { commonFn, onChangeFn } = this.props;

    await commonFn.changeRow({
      type: 'pagerow',
      name: 'value',
      value: data.value
    });

    if (onChangeFn) {
      onChangeFn();
    }
  };

  render() {
    return (
      <Form.Field inline>
        <Dropdown
          name="pagerow"
          selection
          compact
          defaultValue={10}
          options={state.numOptions}
          onChange={this.handleChange}
        />
      </Form.Field>
    );
  }
}

Pagerow = connect(
  (state) => ({
    pageRow: state.commons.pagerow
  }),

  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeRow: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(Pagerow);

export default Pagerow;
